import {ChangeDetectorRef, Component, forwardRef, HostListener} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractInput} from "../../../framework/abstract-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterTextareaInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-textarea-input",
    styleUrls: ["./filter-textarea-input.component.scss"],
    templateUrl: "./filter-textarea-input.component.html",
    standalone: false
})
export class FUIFilterTextareaInputComponent extends FUIAbstractInput {

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    /**
     * Perform events after a click on the host
     * @param element
     */
    @HostListener("click")
    override click(): void {
        this.focus();
    }
}
